/* src/app/views/smart-filters/components/smart-filter-selection/smart-filter-selection.component.scss */
.bs-light {
  font-family: poppins, sans-serif;
  font-weight: 300;
  font-style: normal;
}
.bs-italic {
  font-family: poppins, sans-serif;
  font-weight: 400;
  font-style: italic;
}
.bs-regular {
  font-family: poppins, sans-serif;
  font-weight: 400;
  font-style: normal;
}
.bs-medium {
  font-family: poppins, sans-serif;
  font-weight: 500;
  font-style: normal;
}
.bs-medium-italic {
  font-family: poppins, sans-serif;
  font-weight: 500;
  font-style: italic;
}
.bs-bold-italic {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-style: italic;
}
.bs-semi-bold {
  font-family: poppins, sans-serif;
  font-weight: 600;
  font-style: normal;
}
.bs-semi-bold-italic {
  font-family: poppins, sans-serif;
  font-weight: 600;
  font-style: italic;
}
.bs-bold {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-style: normal;
}
.f12px {
  font-size: 0.75rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
.smart-filter-selection-container {
  padding: 1rem 0;
}
.smart-filter-selection-container.child {
  margin-left: 1.5rem;
}
.smart-filter-selection-container.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.smart-filter-name {
  font-size: 0.875rem;
  font-family: poppins, sans-serif;
  font-weight: 400;
  font-style: normal;
  color: #222222;
}
.smart-filter-variant-hit-count {
  font-size: 0.875rem;
  font-family: poppins, sans-serif;
  font-weight: 400;
  font-style: normal;
  color: #9fa2ad;
}
/*# sourceMappingURL=smart-filter-selection.component.css.map */
